<div class="container">
  <div class="input-container">
    <input #input class="input" type="text" [value]="SearchTerm" (input)="SetSearchTermEvent($event)" (click)="onInputClick()" (keydown)="HandleKeyDown($event)"/>
  </div>
  <div class="dropdown" [ngClass]="IsDropdownOpen ? 'is-active' : ''">
    <div #dropdownMenu class="dropdown-menu" id="dropdown-menu" role="menu">
      <div class="dropdown-content">
        @for (category of FilteredCategories; track category) {
          <div class="dropdown-header">
            {{category.category}}
          </div>
          <hr class="dropdown-divider">
          @for (item of category.items; track item) {
            <a
              (click)="SelectItem(item)"
              class="dropdown-item"
              [title]="item.Description">
              {{item.Name}}
            </a>
          }
          <hr class="dropdown-divider">
        }
      </div>
    </div>
  </div>
</div>